export default "__VITE_ASSET__fc0eb795__"